import { PLAYER_TYPE } from "./player_type";
import PlaySound from "./play_sound";
import EventBus from '../../event_bus';
export default class PlaySoundComplete extends PlaySound {
    normalFrame = 0;    //按鈕普通狀態的影格，預設為0
    constructor(el, target) {
        super(el, target);
        this.connectNumber = this.el.connectNumber;
        this.needPlayer = true;
        this.playerType = PLAYER_TYPE.FULL;
    }

    trigger() {
        EventBus.getInstance()._app.audioConfig.timeSteps = [0];
        EventBus.getInstance().getAppRefs().soundManager.setDefaultAudioConfig([0]);
        super.trigger();
    }
}